var React = require('react');

function CircleArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32","cy":"32","r":"31.5","stroke":"#E9EBEC","key":0}),React.createElement("g",{"clipPath":"url(#clip0_10985_1458)","key":1},[React.createElement("path",{"d":"M22.5731 32H41.4303","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M33.7159 24.2852L41.4302 31.9994L33.7159 39.7137","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_10985_1458"},React.createElement("rect",{"width":"27.4286","height":"27.4286","fill":"white","transform":"translate(18.2874 18.2852)"})))]);
}

CircleArrow.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = CircleArrow;

CircleArrow.default = CircleArrow;
